export default __webpack_public_path__ + "static/media/timeline.ab2cf133.svg";